import { IConfig } from '@cian/config/shared';

import { useApplicationContext } from '../../../containers/ApplicationContext';

export function checkHotelsEnabled(config: IConfig) {
  return Boolean(config.get<boolean>('Dailyrent.HotelsSearchFrontend.Enabled'));
}

export function useHotelsEnabled(): boolean {
  const { config } = useApplicationContext();

  return checkHotelsEnabled(config);
}
